import Icon from '@tiger/icons';
import { FC, useDeferredValue, useEffect, useMemo, useRef, useState } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { CountryData } from 'types/common';
import { getSearchCountryData } from 'utils/helper';
import styles from './style.scss';

interface PortalPCProps {
    countryData: CountryData[];
    onChange: (value: string) => void;
    handleShow: (isShow: boolean) => void;
    countryCode?: string;
}

const PortalPC: FC<PortalPCProps> = ({ countryData, countryCode, onChange, handleShow }) => {
    const [searchValue, setSearchValue] = useState<string>('');
    const selectedRef = useRef<HTMLDivElement>(null);
    const deferredSearchValue = useDeferredValue(searchValue);
    const filteredData = useMemo(() => {
        const lowerSearchValue = deferredSearchValue.toLowerCase();

        return lowerSearchValue ? getSearchCountryData(countryData, lowerSearchValue) : countryData;
    }, [deferredSearchValue, countryData]);
    const panelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (selectedRef.current) {
            // 因为存在热门/普通国家代码相同的情况，所以需要确保只滚动到第一个匹配的元素
            document.querySelector(`.${styles.item}[data-code="${countryCode}"]`)?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [countryCode]);

    useEffect(() => {
        const hidePCPanel = (ev: MouseEvent) => {
            if (panelRef.current && !panelRef.current.contains(ev.target as HTMLDivElement)) {
                handleShow(false);
            }
        };

        window.addEventListener('click', hidePCPanel, true);

        return () => {
            window.removeEventListener('click', hidePCPanel, true);
        };
    }, [handleShow]);

    return (
        <div className={styles.pcRoot} ref={panelRef}>
            <InputGroup className={styles.header}>
                <InputGroup.Text className={styles.iconContainer}>
                    <Icon type="search" className={styles.icon} />
                </InputGroup.Text>
                <FormControl
                    className={styles.search}
                    placeholder={__('搜索')}
                    onChange={ev => setSearchValue(ev.target.value)}
                />
            </InputGroup>
            <section className={styles.list}>
                {filteredData.map(({ letter, items }) => (
                    <div key={letter} className={styles.letterList}>
                        <h5 className={styles.title}>{letter}</h5>
                        <>
                            {items.map(({ country_code, country_name, country }) => {
                                const isSelected = countryCode === country_code;

                                return (
                                    <div
                                        key={country_code}
                                        ref={isSelected ? selectedRef : null}
                                        data-code={country_code}
                                        className={styles.item}
                                        onClick={() => onChange(country_code)}>
                                        {country_name || country}
                                        {isSelected && <Icon type="check" className="fs-4" />}
                                    </div>
                                );
                            })}
                        </>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default PortalPC;
